import { OnboardingFlow } from './shared/onboarding-types';

/**
 * Onboarding flow configuration for Analytics Detail Page
 * This flow shows users how to navigate the AI solution detail view
 */
export const analyticsDetailOnboarding: OnboardingFlow = {
  id: 'analytics-detail',
  name: 'AI Solution Analytics Walkthrough',
  steps: [
    {
      id: 'analytics-tabs',
      element: '[data-testid="analytics-detail-tabs"]',
      title: 'Switch analytics views',
      description:
        'Tabs let you change what type of data is shown for this AI solution. From overall performance to detailed findings and concordance metrics.',
      popover: { side: 'bottom', align: 'center' },
    },
  ],
};
